import { createSelector } from 'reselect'

import { selectPartner360Data } from './selectPartner360Data'

export const selectProgramTypesExtended = createSelector(
  [selectPartner360Data],
  ({ programTypesExtended }) => programTypesExtended
)
